import { BrandVariants, Theme, createDarkTheme, createLightTheme } from "@fluentui/react-components";

const tealThemeVar: BrandVariants = {
    10: "#020403",
    20: "#111B19",
    30: "#182E29",
    40: "#1C3B35",
    50: "#214941",
    60: "#25574E",
    70: "#28665A",
    80: "#2C7568",
    90: "#2F8475",
    100: "#329483",
    110: "#35A491",
    120: "#37B49F",
    130: "#39C5AE",
    140: "#56D3BD",
    150: "#87DECC",
    160: "#AFE9DC"
};

const tealLightTheme1: Theme = {
    ...createLightTheme(tealThemeVar),
};

const tealDarkTheme1: Theme = {
    ...createDarkTheme(tealThemeVar),
};

tealDarkTheme1.colorBrandForeground1 = tealThemeVar[110];
tealDarkTheme1.colorBrandForeground2 = tealThemeVar[120];



const tealTheme2Var: BrandVariants = {
    10: "#020404",
    20: "#101B1B",
    30: "#172E2D",
    40: "#1A3B3A",
    50: "#1D4948",
    60: "#205756",
    70: "#226664",
    80: "#247573",
    90: "#258482",
    100: "#259492",
    110: "#25A4A2",
    120: "#23B4B2",
    130: "#21C5C2",
    140: "#1DD5D3",
    150: "#17E6E3",
    160: "#7FF0ED"
};

const tealLightTheme2: Theme = {
    ...createLightTheme(tealTheme2Var),
};

const tealDarkTheme2: Theme = {
    ...createDarkTheme(tealTheme2Var),
};
tealDarkTheme2.colorBrandForeground1 = tealTheme2Var[110];
tealDarkTheme2.colorBrandForeground2 = tealTheme2Var[120];



const reddishTheme: BrandVariants = {
    10: "#070200",
    20: "#281005",
    30: "#441609",
    40: "#5B190B",
    50: "#731B0C",
    60: "#8D1C0C",
    70: "#A71B0C",
    80: "#C1190B",
    90: "#DD1308",
    100: "#F90606",
    110: "#FF4427",
    120: "#FF6948",
    130: "#FF8567",
    140: "#FF9E84",
    150: "#FFB5A0",
    160: "#FFCABB"
};

const reddishLightTheme: Theme = {
    ...createLightTheme(reddishTheme),
};

const reddishDarkTheme: Theme = {
    ...createDarkTheme(reddishTheme),
};


reddishDarkTheme.colorBrandForeground1 = reddishTheme[110];
reddishDarkTheme.colorBrandForeground2 = reddishTheme[120];


const blueishTheme: BrandVariants = {
    10: "#070011",
    20: "#0E0658",
    30: "#081081",
    40: "#1A1F91",
    50: "#272DA0",
    60: "#343BAE",
    70: "#414ABB",
    80: "#4E58C7",
    90: "#5B67D3",
    100: "#6976DD",
    110: "#7786E6",
    120: "#8695EE",
    130: "#96A5F4",
    140: "#A7B5F9",
    150: "#B8C5FD",
    160: "#CAD5FF"
};

const blueishLightTheme: Theme = {
    ...createLightTheme(blueishTheme),
};

const blueishDarkTheme: Theme = {
    ...createDarkTheme(blueishTheme),

    colorNeutralBackground1: '#192134',
    colorNeutralBackground2: '#131A2C',
    colorNeutralBackground3: '#202b45',
    colorNeutralCardBackground: '#0B1221', //0B1221
    colorBrandBackground4Static: '#101939',
    colorBrandBackgroundSelected: '#202A4B',
    colorBrandBackgroundHover: '#263259',
    colorNeutralBackground5: '#192134',
    colorNeutralBackground5Hover: '#202b45',
};

blueishDarkTheme.colorBrandForeground1 = blueishTheme[110];
blueishDarkTheme.colorBrandForeground2 = blueishTheme[120];

const theCaseWorkDarkBrandRamp = {
    10: '#0A0D12',
    20: '#0E121A',
    30: '#121725',
    40: '#151B2E',
    50: '#182037',
    60: '#1A2440',
    70: '#1C2849',
    80: '#1E2D53',
    90: '#20315C',
    100: '#223566', // primary brand (dark mode)
    110: '#2A447A',
    120: '#33548F',
    130: '#3D63A3',
    140: '#4673B8',
    150: '#5082CC',
    160: '#5A92E0',
};

const theCaseWorkDarkTheme: Theme = {
    ...createDarkTheme(theCaseWorkDarkBrandRamp),
};


export const themes = {
    tealDarkTheme1,
    tealDarkTheme2,
    tealLightTheme1,
    tealLightTheme2,
    reddishLightTheme,
    reddishDarkTheme,
    blueishDarkTheme,
    blueishLightTheme,
    theCaseWorkDarkTheme,
};
